(ns ui.components.tiptap.view
  (:require
   [oops.core :as oops]
   [reagent.core :as r]
   [ui.components.tiptap.mention-suggestion :refer [mention-suggestion]]
   ["@tiptap/core" :refer [Editor]]
   ["@tiptap/starter-kit" :default StarterKit]
   ["@tiptap/extension-underline" :default Underline]
   ["@tiptap/extension-mention" :default Mention]
   [ui.util :as uu]))

(defn view
  [{:keys [_value _on-change _trigger-char _item-texts _class]}]
  (let [editor-atom   (r/atom nil)
        container-ref (atom nil)]
    (r/create-class
     {:display-name "tiptap-mention-editor"

      :component-did-mount
      (fn [this]
        (let [{:keys [value on-change trigger-char item-texts]} (r/props this)
              tiptap-editor
              (Editor.
               #js {:element    @container-ref
                    :extensions #js [StarterKit
                                     Underline
                                     (oops/ocall+ Mention "configure"
                                                  #js {:HTMLAttributes #js {:class "mention"}
                                                       :renderLabel    (fn [props]
                                                                         (let [attrs (oops/oget+ (oops/oget+ props "node") "attrs")]
                                                                           (str (aget attrs "id"))))
                                                       :renderText     (fn [props]
                                                                         (str "{{" (oops/oget props "node.attrs.id") "}}"))
                                                       :suggestion     (mention-suggestion
                                                                        {:trigger-char (or trigger-char "@")
                                                                         :item-texts   (if (seq item-texts)
                                                                                         item-texts
                                                                                         [])})})]
                    :content    (or value "")
                    :onUpdate   (fn [update]
                                  (let [ed   (oops/oget update "editor")
                                        json (oops/ocall+ ed "getJSON")
                                        html (oops/ocall+ ed "getHTML")
                                        text (oops/ocall+ ed "getText")]
                                    (when on-change
                                      (on-change text html (js->clj json :keywordize-keys true)))))})]
          (reset! editor-atom tiptap-editor)))

      :component-will-unmount
      (fn [_]
        (when-let [ed @editor-atom]
          (.destroy ed)))

      :reagent-render
      (fn [{:keys [class]}]
        [:div {:class (uu/cm "border p-2 min-h-[200px] flex flex-col cursor-text"
                             "[&>div]:flex-auto"
                             "[&_.ProseMirror]:outline-none"
                             "[&_.ProseMirror]:h-full"
                             class)
               :ref   (fn [el] (reset! container-ref el))}
         [:style ".mention { background-color: #e2e8f0; border-radius: 0.25rem; padding: 0.125rem 0.25rem; font-weight: 500; }"]])})))
